import { IDropdownOption } from '@fluentui/react';

import { AppState } from '../../../../redux/reducers';
import { Contract } from '../../../../models/Entities/Contracts/Contract';

//stores 
import * as ContractStore from '../../../../redux/middleware/ContractMiddleware'
import { ErrorType } from '../../../../models/HttpError';



//#region Props

interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  Contract?: Contract;
  mode: string;
  RefererId: string | number | undefined;
}

interface ConnectedProps {
  isLoading: boolean;
  isUpdating: boolean;
  isUpdatedSuccessfully: boolean;
  isLoadingSuccessfully: boolean;
  failOnUpdating: boolean;
  failOnLoading: boolean;
  isDeleting: boolean;
  isDeletedSuccessfully: boolean;
  failOnDeleting: boolean;
  isAdding: boolean;
  isAddedSuccessfully: boolean;
  error: ErrorType | undefined;
  Contracts: Contract[];
}

interface MedicalServicesDispatchProps {
  GetAllContracts: typeof ContractStore.actionCreators.GetAllContracts;
  GetContractById: typeof ContractStore.actionCreators.GetContractById;
  AddContract: typeof ContractStore.actionCreators.AddContract;
  UpdateContract: typeof ContractStore.actionCreators.UpdateContract;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.Contract?.isLoadingOne,
  isUpdating: state.Contract?.isUpdatingOne,
  isUpdatedSuccessfully: state.Contract?.successUpdatingOne,
  isLoadingSuccessfully: state.Contract?.successLoadingOne,
  failOnUpdating: state.Contract?.failOnLoadingAll,
  failOnLoading: state.Contract?.failOnLoadingAll,
  isDeleting: state.Contract?.isDeletingOne,
  isDeletedSuccessfully: state.Contract?.successDeletingOne,
  failOnDeleting: state.Contract?.failOnDeletingOne,
  isAdding: state.Contract?.isAddingNewOne,
  isAddedSuccessfully: state.Contract?.successAddingNewOne,
  error: state.Contract?.error,
  Contracts: state.Contract?.list
});

export const mapDispatchToProps = {
  ...ContractStore.actionCreators
};

//#endregion Props


export const ContractStatusOptions: IDropdownOption[] = [
  { key: '1', text: 'Active' },
  { key: '2', text: 'Inactive' },
  { key: '3', text: 'Suspended' },
  { key: '4', text: 'Expired' },
  { key: '5', text: 'Canceled' },
  { key: '6', text: 'Terminated' }
];

export const ContractPaymentScheduleTypeOptions: IDropdownOption[] = [
  { key: '1', text: 'Diario' },
  { key: '2', text: 'Semanal' },
  { key: '3', text: 'Mensual' },
  { key: '4', text: 'Pago Unico' },
  { key: '5', text: 'A Demanda' }
];
